export class Ref {
    constructor(value) {
        this.value = value;
    }
    // Convert our type to JSON.
    toJSONValue() {
        return {
            value: this.value,
        };
    }
    // Unique type name.
    typeName() {
        return 'Ref';
    }
}
//# sourceMappingURL=ref.js.map